<div *ngIf="!!items?.length" class="lb-feed" infiniteScroll [infiniteScrollDistance]="2" [infiniteScrollThrottle]="100"
  [scrollWindow]="false" [infiniteScrollDisabled]="!hasMoreData" (scrolled)="triggerLoadMore()">
  <div class="lb-feed__header">
    <span class="lb-live-dot" aria-hidden="true"></span>
    <span class="lb-feed__title">Live</span>
    <span class="lb-feed__count">{{ items.length }} participant{{ items.length === 1 ? '' : 's' }}</span>
  </div>

  <div class="lb-row" *ngFor="let item of items">
    <div class="lb-row__rail">
      <div class="lb-avatar" [attr.title]="getFullName(item) || item?.email || ''">
        <ng-container *ngIf="
            item?.profileImage?.media_name !== 'null' &&
              item?.profileImage?.presigned_url;
            else initialsOnly
          ">
          <img class="lb-avatar__img" [src]="item?.profileImage?.presigned_url"
            [alt]="getFullName(item) || 'User avatar'" loading="lazy" />
        </ng-container>
        <ng-template #initialsOnly>
          <span class="lb-avatar__initials">{{ getInitials(item) }}</span>
        </ng-template>
        <span class="lb-avatar__status" aria-hidden="true"></span>
      </div>
      <span class="lb-row__thread" aria-hidden="true"></span>
    </div>

    <div class="lb-row__body">
      <div class="lb-row__name">
        {{ item?.first_name }} {{ item?.last_name }}
      </div>
      <div class="lb-row__email">{{ item?.email }}</div>
    </div>
  </div>

  <div class="lb-loading" *ngIf="loading">
    <span class="lb-loading__dot"></span>
    <span class="lb-loading__dot"></span>
    <span class="lb-loading__dot"></span>
    <span class="lb-loading__text">Loading more</span>
  </div>
</div>